// Fallback theme applied to any org that hasn't customized their branding yet.
export const defaultOrgTheme = {
  primary: "29 100% 50%",       // same orange, as sensible default
  primaryForeground: "0 0% 100%",
  secondary: "210 40% 96.1%",
  accent: "24 100% 95%",
};